import { useNavigate, Link } from "react-router-dom";


function SideBar({addedGoods, years, selectedYear, currentYear, setSelectedYear}) {
 
  const navigate = useNavigate();

  function setYear(year) {
    setSelectedYear(year);
    console.log(year);
    localStorage.setItem('selectedYear', year);
    navigate("/");
    navigate(0);
  }

  let rows=[]
  for (let i in years) {
    rows.push(
      <button key={years[i]} className="lk-button dropdown-item" type="button" onClick={() => setYear(years[i])}>
        {years[i]}
      </button>
    )
  }

  return(
    <>
      <div className="left-panel h-100 pt-4">
        <div className="px-4 ms-2 me-3">
            <nav className="navbar navbar-expand-lg">
              <button className="lk-year-button dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                <p>год договора</p>
                {selectedYear}
              </button>
              <ul className="dropdown-menu lk-year-dropdown">
                {rows}
              </ul>
            </nav>

        </div>
        <nav className="nav flex-column p-3">
          <li className="nav-link"><Link className="lk-link" to={`profile`}>Профиль пользователя</Link></li>
          {selectedYear < currentYear ? "" :
            <li className="nav-link"><Link className="lk-link" to={`/`}>Каталог</Link></li> 
          }  
          <li className="nav-link"><Link className="lk-link" to={`order`}>Заказ и договор</Link></li> 
          <li className="nav-link"><Link className="lk-link" to={`tickets`}>Обращения</Link></li>
          
          <hr></hr>
          <li className="nav-link"><Link className="lk-link" to={`task_list`}>Формы</Link></li>
        </nav>
        <div className='position-absolute bottom-0 start-50 translate-middle-x mb-3'>
          <p className="text-center">МСИ «ФСВОК» {selectedYear}</p>
        </div>
      </div>  
    </>
  );
}

export default SideBar